import React, { ReactNode } from 'react';

type HeaderItemProps = {
	children: ReactNode;
};

const HeaderItem = ({ children }: HeaderItemProps) => {
	return <div className="mx-2 flex h-6 shrink-0 items-center text-[11px] text-aqua-pale">{children}</div>;
};

export default HeaderItem;
